const setCookie = (name, value, days = 7, path = '/') => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
}

const getCookie = (name) => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=')
    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, '') 
}

const deleteCookie = (name, path) => {
  setCookie(name, '', -1, path)
}

const setCartCookie = (name, value, days = 7, path = '/') => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
}

const getCartCookie = (name) => {
  return document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=')
    return parts[0] === name ? decodeURIComponent(parts[1]) : r
  }, '')
}

const deleteCartCookie = (name, path) => {
  setCookie(name, '', -1, path)
}

const countdown = () => {
  return {
    show: true,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    interval: null,
    updateTimer($this, countdown_text) {
      // Set the date we're counting down to
      var countDownDate = new Date(countdown_text).getTime();
      var now = new Date().getTime();
      var distance = countDownDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      $this.days = days;
      $this.hours = hours;
      $this.minutes = minutes; 
      $this.seconds = seconds;

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval($this.interval); 
        $this.show = false;
      }
    },
    init(countdown_text) {
      var $this = this;
      // Update the count down every 1 second
      $this.updateTimer($this, countdown_text);
      $this.interval = setInterval(function() {
        $this.updateTimer($this, countdown_text);
      }, 1000);
    }
  }
}

async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 8000 } = options;
  
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  const response = await fetch(resource, {
    ...options,
    signal: controller.signal  
  });
  clearTimeout(id);
  return response;
}


function parse_query_string(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);
    // If first entry with this name
    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
      // If second entry with this name
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
      // If third or later entry with this name
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

const discountCodeInfo = () => {
  return {
    show: false,
    text: null,
    init(textTemplate) {
      const cc = getCookie("discount_code");
      var query = window.location.search.substring(1);
      var qs = parse_query_string(query)

      if (cc) {
        let coupon_code = cc.toString();
        coupon_code = coupon_code.split('&')[0];
    
        if (qs.discount_note !== undefined && coupon_code != "") {
          this.text = textTemplate.replace('[discount_code]', coupon_code.toUpperCase())
          this.show = true
          if (window.discountCodeCalculation) {
            setCookie("discount_code_referrer", coupon_code.toUpperCase(), 1);
          }
        }
      }
      
      
      if (window.discountCodeCalculation) {
        const dcr = getCookie("discount_code_referrer");
        if (dcr && window.productData) {
          var coupon_code = dcr.toString();
          var url = `https://secretbrands-checkout-api-2.digitalsprung.de/checkout/${coupon_code.toLowerCase()}/${window.productData.productId}/${window.productData.variantId}?shop=${Shopify.shop}&price=${window.productData.price}`

          fetch(url)
          .then(response => response.json())
          .then(data => {
            if (data?.status == 'valid') {
              window.dispatchEvent( new CustomEvent('product-discount', {'detail': data}) );
            }
          });
        }
      }
    }
  }
}



var EasyCart = (function (module, $) {
  
  const hooks = [];
  let registerHook;
  let callHook;

  registerHook = function (name, callback) {
    if (typeof hooks[name] === 'undefined') {
      hooks[name] = [];
    }
    hooks[name].push(callback);
  };

  hasRegisteredHook = function (name, callback) {
    if (typeof hooks[name] !== 'undefined') return true;
    return false;
  }; 

  callHook = function (name, args) {
    // console.log("callHook", name, args);
    if (typeof hooks[name] !== 'undefined')
      for (let i = 0; i < hooks[name].length; ++i)
        if (hooks[name][i](args) != true) {
          break;
        }
  };

  module = {
    registerHook,
    callHook,
    debugMode: false
  };

  return module;
})(EasyCart || {}, jQuery); 


if (typeof ShopifyAPI === 'undefined') {
  ShopifyAPI = {};
}

// POST to cart/update.js returns the cart in JSON
ShopifyAPI.updateCart = function (cartUpdates, callback) {
  const items = CartJS.cart.items;

  const keys = Object.keys(cartUpdates);
  const cartJSUpdates = [];
  // console.log(cartUpdates);
  let updated = false;
  const add = [];
  for (var i = 0; i < keys.length; i++) {
    let found = false;

    const id = parseInt(keys[i]);
    const quantity = parseInt(cartUpdates[id]);
    const timer = 1000;

    for (let j = 0; j < items.length; j++) {
      if (items[j].id == id) {
        found = true;
      }
      if (items[j].id == id && items[j].quantity != quantity && !updated) {
        // console.log("updateItem", items, j + 1, quantity);
        CartJS.updateItem(j + 1, quantity);
        updated = true;
      }
    }

    if (!found) {
      add.push({
        id,
        quantity,
      });
    }
  }

  for (var i = 0; i < add.length; i++) {
    CartJS.addItem(add[i].id, add[i].quantity);
  }
};

 
const cartDrawer = () => {
  return {
    open: false,
    cart: null,
    items: [],
    freeItems: [],
    loading: false,
    upsells: [],
    discountCode: null,
    validDiscountCode: "",
    freeShippingFrom: 5000,
    checkoutCart: {
      total: 0,
      subtotal: 0,
      discount: 0
    },
    codeStatus: null,
    usedKeyboard: false,
    cartUpsells: {},
    cartConfig: {},
    choiceOverlay: false,
    selectedFreeIds: [],
    freeProducts: [],
    giftSelectionSuccessful: false,
    selectedFreeVariants: [],
    maxFreeProducts: -1,
    prices: [],
    initChoiceOverlay(args) {
      const {maxFreeProducts, freeProducts} = args;
      let currentFreeProductsCount = this.items.filter(item => item.price == 0)
      let freeProductFound = false
      let freeProductsFoundCount = 0

      if (currentFreeProductsCount > maxFreeProducts) {
        let i = 1;
        for (const item of this.items) {
          if (item.price == 0) {
            CartJS.removeItem(i)
          }
          i++;
        }
      } else {
        for (const freeProduct of freeProducts) {
          const f = this.items.find(item => item.variant_id == freeProduct.variants[0].variantId)
          if (f) {
            freeProductsFoundCount++
          }
        }
      }
      //console.log("freeProductsFoundCount: " + freeProductsFoundCount)

      this.maxFreeProducts = maxFreeProducts
      this.freeProducts = freeProducts
      for (const product of this.freeProducts) {
        product.product_worth = "";
        product.available = true;
      }

      if (freeProductsFoundCount < maxFreeProducts) {
        this.openChoiceOverlay();
      }
    },
    confirmGiftChoice() {
      if (this.selectedFreeVariants.length < this.maxFreeProducts) {
        const free = this.maxFreeProducts - this.selectedFreeVariants.length;
        if (free == 1) {
          alert("Du hast noch ein Geschenk frei");
        } else {
          alert("Du hast noch " + free + " Geschenke frei");
        }
        this.giftSelectionSuccessful = false;
      } else {
        this.giftSelectionSuccessful = true;
        this.choiceOverlay = false;

        let i = 1
        // Remove other free gifts
        for (const item of this.items) {
          const f = this.selectedFreeVariants.find(s => s == item.variant_id)
          if (item.price == 0 && !f) {
            CartJS.removeItem(i)
          }
          i++;
        }

        // Add gifts that are not added yet
        for (const variant_id of this.selectedFreeVariants) {
          let alreadyInCart = false
          const f = this.items.find(item => item.variant_id == variant_id)

          if (f) alreadyInCart = true;

          if (!alreadyInCart) {
            CartJS.addItem(variant_id, 1)
          }
        }
      }
    },
    openChoiceOverlay() {
      this.choiceOverlay = true;
      this.loadImages();
    },
    toggleFreeProduct(product) {
      if (!product.available) {
        return;
      }

      const variant = product.variants[0].variantId
      if (this.selectedFreeVariants.indexOf(variant) == -1) {
        this.selectedFreeVariants.push(variant)
      } else {
        const index = this.selectedFreeVariants.indexOf(variant);
        if (index > -1) {
          //console.log("remove ", variant)
          this.selectedFreeVariants.splice(index, 1);
        }
      }
      if (this.selectedFreeVariants.length > this.maxFreeProducts) {
        this.selectedFreeVariants.splice(0, 1);
      }
    },
    getCompareAtPrice(variantId) {
      const p = this.prices.find(item => {
        const {variants} = item
        const v = variants.find(vItem => vItem.id == variantId)
        return v
      });
      if (p) {
        const {variants} = p
        const v = variants.find(vItem => vItem.id == variantId)
        if (v && v.compare_at_price > 0 && v.compare_at_price > v.price) {
          return v.compare_at_price
        }
      }
      return 0
    },
    compareAtPrice(item) {
      if (item?.properties?._compare_at_price > 0) {
        return item?.properties?._compare_at_price
      }
      return 0
    },
    isFreeProductSelected(product) {
      const f = this.selectedFreeVariants.find(v => v.toString() == product.variants[0].variantId.toString());
      return !!f;
    },
    loadImages() {
      for (const product of this.freeProducts) {
        fetch(`/search?view=id&type=product&q=${encodeURI('id:' + product.productId)}`)
          .then(response => response.json())
          .then(response => {
            if (response.products && response.products.length > 0) {
              if (response.products[0].title) {
                product.title = response.products[0].title;
              }
              product.image = response.products[0].featured_image;
              product.product_worth = response.products[0].product_worth;
              product.available = !!response.products[0].available;
            }
          }).catch(err => {
          })
      }
    }, 
    checkDiscountCode() {
      var $this = this;
      if (this.discountCode && this.cart && this.items.length > 0) {
        this.loading = true;
        
        let code = this.discountCode;
        code = code.trim().toLowerCase();
        if (code && code.indexOf('?') > -1) {
          const codeSplit = code.split("?");
          code = codeSplit[0];
        }
        let shop = Shopify.shop;
        let checkoutVariants = this.items.map(paidItem => {
            return {
              "variant_id": paidItem.variant_id,
              "id": paidItem.variant_id,
              "quantity": paidItem.quantity,
              "properties": {},
              "final_line_price": paidItem.final_line_price
            }
        })
        let payload = {
          "checkout": {
            "country": "DE",
            "discount_code": code,
            "gift_cards": [],
            "line_items": checkoutVariants,
            "presentment_currency": "EUR"
          }
        }
    
        function request() {
          return new Promise(function (resolve, reject) {
            const req = new XMLHttpRequest();
            req.open("POST", "https://"+window.location.host+"/wallets/checkouts/");
            req.onreadystatechange = () => { // Call a function when the state changes.
            }
            const checkoutApiToken = document.querySelector("meta[name='shopify-checkout-api-token']").getAttribute("content")
            req.setRequestHeader('Content-Type', 'application/json');
            req.setRequestHeader("Authorization", "Basic " +btoa(checkoutApiToken));
            req.onload = resolve
            req.onerror = reject
            req.send(JSON.stringify(payload));
          });
        }

          
        request().then(function (e){
          const responseCheckout = JSON.parse(e.target.response)
          const checkout = responseCheckout.checkout
          //console.log(checkout)

          if (!checkout) {
            setTimeout(() => {
              $this.loading = false;
            }, 500)
              
            $this.codeStatus = "invalid";
            
            $this.checkoutCart.total = $this.cart.total_price;
            $this.checkoutCart.subtotal = $this.cart.total_price;
            $this.checkoutCart.discount = 0;
            return
          }
          
          const {applied_discount} = checkout
          if (applied_discount?.title?.toLowerCase() == code?.toLowerCase() && applied_discount?.applicable) {
            $this.codeStatus = "valid";
            const total_price = (parseFloat(checkout.total_line_items_price) * 100);
            const total_after_discount = (parseFloat(checkout.total_price) * 100);
            const discount = (parseFloat(applied_discount.amount) * 100);
            $this.checkoutCart.total = total_after_discount;
            $this.checkoutCart.subtotal = total_price;
            $this.checkoutCart.discount = discount;
          } else {
            $this.codeStatus = "invalid";
            $this.checkoutCart.total = $this.cart.total_price;
            $this.checkoutCart.subtotal = $this.cart.total_price;
            $this.checkoutCart.discount = 0;
          }

          
          if (applied_discount?.applicable) {
            $this.validDiscountCode = code.trim().toUpperCase()
            setCartCookie("discount_code", code.trim().toUpperCase(), 1);
            
            var vdc = document.getElementById("cartDiscountCode");
            if (vdc) {
              vdc.value = code.trim().toUpperCase();
            }

            var vd = document.getElementById("cartDiscount");
            if (vd) {
              vd.value = code.trim().toUpperCase();
            }

            

            setTimeout(function () {
              var cartItems = CartJS.cart.items;
              var items = [];
              let price = 0;
              let total = 0;
              for (var i = 0; i < cartItems.length; i++) {
                items.push({
                  variant: cartItems[i].variant_id,
                  price: cartItems[i].price,
                  quantity: cartItems[i].quantity
                })
                total += cartItems[i].price * cartItems[i].quantity;
                price += cartItems[i].price;
              }
              if (price == 0) {
                CartJS.clear();
              } else {
                if (code.trim().toLowerCase().indexOf("bday") > -1
                  || code.trim().toLowerCase().indexOf("special") > -1
                  || code.trim().toLowerCase().indexOf("1year") > -1) {
                  const k = cartItems.find(item => item.variant_id == 43751988101386)
                  if (!k && total >= 8000) {
                    CartJS.addItem(43751988101386, 1)
                  } else if (k && total < 8000) {
                    const ki = cartItems.findIndex(item => item.variant_id == 43751988101386)
                    CartJS.removeItem(ki + 1)
                  }
                  /**/

                  /**document.dispatchEvent(new CustomEvent('EasyCart:after_discount_code_check', {
                    detail: {
                      code: code.trim(),
                      items: items
                    }
                  }));*/

                  //EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
                } else {
                  EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
                }
              }
            }, 500);
          }
          
          setTimeout(() => {
            $this.loading = false;
          }, 500)
        });

        
        /*const data = { cart: JSON.parse(JSON.stringify(this.cart)), code: code, shop: shop };
        try {
          fetchWithTimeout('https://secretbrands-checkout-api-2.digitalsprung.de/checkout', {
            timeout: 8000,
            method: 'POST', // or 'PUT'
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
          .then(response => response.json())
          .then(data => {
            setTimeout(() => {
              $this.loading = false;
            }, 500)
            this.codeStatus = data.status;
            if (data.checkoutCart) {
              this.checkoutCart = data.checkoutCart;
            } else {
              this.checkoutCart.total = this.cart.total_price;
              this.checkoutCart.subtotal = this.cart.total_price;
              this.checkoutCart.discount = 0;
            }
            if (data.status == 'valid') {
              this.validDiscountCode = code.trim().toUpperCase()
              setCartCookie("discount_code", code.trim().toUpperCase(), 1);
  
              var vdc = document.getElementById("cartDiscountCode");
              if (vdc) {
                vdc.value = code.trim().toUpperCase();
              }
  
              var vd = document.getElementById("cartDiscount");
              if (vd) {
                vd.value = code.trim().toUpperCase();
              }



              setTimeout(function () {
                var cartItems = CartJS.cart.items;
                var items = [];
                let price = 0;
                let total = 0;
                for (var i = 0; i < cartItems.length; i++) {
                  items.push({
                    variant: cartItems[i].variant_id,
                    price: cartItems[i].price,
                    quantity: cartItems[i].quantity
                  })
                  total += cartItems[i].price * cartItems[i].quantity;
                  price += cartItems[i].price;
                }
                if (price == 0) {
                  CartJS.clear();
                } else {
                  if (code.trim().toLowerCase().indexOf("bday") > -1
                    || code.trim().toLowerCase().indexOf("special") > -1
                    || code.trim().toLowerCase().indexOf("1year") > -1) {
                    const k = cartItems.find(item => item.variant_id == 43751988101386)
                    if (!k && total >= 8000) {
                      CartJS.addItem(43751988101386, 1)
                    } else if (k && total < 8000) {
                      const ki = cartItems.findIndex(item => item.variant_id == 43751988101386)
                      CartJS.removeItem(ki + 1)
                    }

                    //EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
                  } else {
                    EasyCart.callHook('after_discount_code_check', [code.trim(), items]);
                  }
                }
              }, 500);
            } else {
              this.validDiscountCode = null;
            }
          }).catch(err => {
            setTimeout(() => {
              $this.loading = false;
            }, 500)
          })
        } catch (error) {
          setTimeout(() => {
              $this.loading = false;
            }, 500)
        }
        */
      }
    },
    width() {
      if (this.checkoutCart.total < this.freeShippingFrom) {
        return Math.abs(this.checkoutCart.total / this.freeShippingFrom * 100);
      }
      return 100
    },
    updateUpsells() {
      let upsells = this.cartUpsells
      let _upsells = []
      let _allUpsellProducts = []
      let removeProducts = []
      const $this = this
      const upsellRulesApplied = []
      for (const upsell of upsells) {
        const {mandatory_products, upsell_products} = upsell
        let ruleApplied = true
        for (const mandatoryProduct of mandatory_products) {
          
          const isInCart = $this.items.find(item => item.product_id == mandatoryProduct.id)
          if (!isInCart) {
            ruleApplied = false
          }

          upsellRulesApplied.push(upsell)
          for (const upsellProduct of upsell_products) {
            const upsellProductIsInCart = $this.items.find(item => item.product_id == upsellProduct.id)
            if (!isInCart && upsellProductIsInCart) {
              removeProducts.push(upsellProduct.id)
            }
          }
        }
        if (ruleApplied) {
          for (const upsellProduct of upsell_products) {
            const alreadyInUpsell = _upsells.find(item => item.id == upsellProduct.id)
            const isInCart = $this.items.find(item => item.product_id == upsellProduct.id)
            if (!alreadyInUpsell && !isInCart) {
              _upsells.push(upsellProduct)
            }
            _allUpsellProducts.push(upsellProduct.id)
          }
        }
      }
      _upsells = _upsells.slice(0, this.cartConfig.maxUpsells)
      this.upsells = _upsells

      for (const productId of removeProducts) {
        const isInUpsell = _allUpsellProducts.find(item => item == productId)
        if (!isInUpsell) {
          const i = $this.items.findIndex(item => item.product_id == productId)
          CartJS.removeItem(i + 1)
          return
        }
      }
    },
    /*
    updateCart(cart) {
      if (cart) {
        this.cart = cart
        this.items = cart.items
        const $this = this
        
        setTimeout(() => {
          $this.loading = false
        }, 300)
        if ($this.firstTimeOpened) {
          $this.applyDiscountCode()
        }
      }
    },*/
    updateCart(cart) {
      this.cart = cart;
      this.items = cart.items;
      this.freeItems = this.items.filter(item => item.price == 0)
      this.checkDiscountCode();
      this.updateUpsells();
    },
    init({cart, upsells, config, prices}) {
      this.cart = cart;
      this.cartUpsells = upsells;
      this.cartConfig = config;
      if (prices) {
        this.prices = prices
      } 
      this.checkoutCart.total  = this.cart.total_price 
      var discountCodeCookie = getCookie('discount_code');
      if (discountCodeCookie) {
        this.discountCode = discountCodeCookie;
      }
      this.items = cart.items;
      this.freeItems = this.items.filter(item => item.price == 0)
      if (upsells?.length) {
        this.updateUpsells()
        //this.upsells = upsells[0].upsell_products;
      }
      this.$watch('open', value => {
        value && this.$refs.closeButton.focus()
        if (value && this.discountCode && this.cart.item_count > 0) {
          this.checkDiscountCode();
        }
        this.toggleOverlay()
      })
      this.toggleOverlay()
    },
    image(item) {
      let image = item.featured_image.url
      image = image.replace(".png", "_100x.png")
      image = image.replace(".jpg", "_100x.jpg")
      image = image.replace(".jpeg", "_100x.jpeg")
      return image
    },
    shippingDiff(text, format) {
      var total = (this.checkoutCart !== undefined && this.checkoutCart.total > 0) ? this.checkoutCart.total : 0;
      const diff = this.freeShippingFrom - this.checkoutCart.total;
      const t = text.replace("[money]", Shopify.formatMoney(diff, format))
      return t
    },
    cartTotalSavings() {
      let totalSavings = 0
      let hasComparePrice = false
      for (const item of this.items) {
        let price = item?.quantity * item?.original_price
        let savings = 0
        if (item?.properties?._compare_at_price) {
          const compareAtPrice = parseInt(item?.properties?._compare_at_price)
          if (compareAtPrice > 0) {
            hasComparePrice = true
            savings = compareAtPrice * item?.quantity - price
          }
          console.log(item?.properties?._compare_at_price, item?.original_price, item?.quantity)
        }
        totalSavings += savings
      }
      if (hasComparePrice) {
        return totalSavings + this.checkoutCart.discount;
      }
      return this.checkoutCart.discount
    },
    cartOriginalTotal() {
      let total = 0
      let hasComparePrice = false
      for (const item of this.items) {
        let price = item?.quantity * item?.original_price
        if (item?.properties?._compare_at_price) {
          const compareAtPrice = parseInt(item?.properties?._compare_at_price)
          if (compareAtPrice > 0) {
            hasComparePrice = true
            price = compareAtPrice * item?.quantity
          }
        }
        //console.log(item?.original_price, price, item?.properties?._compare_at_price)
        total += price
      }
      if (hasComparePrice) {
        return total;
      }
      return this.checkoutCart?.subtotal
    },
    discountApplied(text, format) {
      if (this.checkoutCart) {
        let t = text.replace("[money]", Shopify.formatMoney(this.checkoutCart.discount, format))
        t = t.replace("[code]", this.validDiscountCode)
        return t
      }
      return ""
    },
    plus(index, item) {
      CartJS.addItem(item.id, 1, item?.properties);
    },
    addVariant(variantId) {
      CartJS.addItem(variantId, 1, {});
    },
    minus(index, quantity) {
      CartJS.updateItem(index + 1, quantity);
    },
    update(index, quantity) {
      const newQty = quantity > 99 ? 99 : quantity;
      CartJS.updateItem(index + 1, newQty);
    },
    toggleOverlay() {
      document.body.classList[this.open ? 'add' : 'remove']('tw-h-screen', 'tw-overflow-hidden')
    }
  }
}
